import script from "./StaffRegistry.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffRegistry.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__